import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import { trackCTA } from '../utils/analytics';

const About = () => {
  return (
    <>
      <SEOHead
        title="About IDGate"
        description="IDGate was built to replace paper registers and manual ID checks with a single, auditable Aadhaar-verified check-in flow — designed for hotels, resorts, and any regulated business in India."
        keywords="about IDGate, Aadhaar check-in platform, identity verification India, hotel compliance software, UIDAI partner, DPDP compliant software"
        url="https://idgate.in/about"
      />

      <div className="border-b border-slate-200 bg-white">
        <div className="container-custom py-16 lg:py-20">
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            className="mx-auto max-w-3xl"
          >
<h1 className="text-4xl font-bold tracking-tight text-slate-900">
              Identity at the door should be calm, clear, and auditable
            </h1>
            <p className="mt-6 text-lg leading-relaxed text-slate-600">
              IDGate exists because check-in is where trust becomes real: guests
              arrive tired, staff are juggling a dozen systems, and compliance
              expectations do not pause for peak season. We build software that
              makes identity steps explicit, repeatable, and integrated—so the
              front desk can focus on hospitality, not guesswork.
            </p>
            <p className="mt-4 text-lg leading-relaxed text-slate-600">
              Our product lineage is rooted in hotel check-in, with room to extend
              the same primitives to other regulated entry journeys as partners
              need them.
            </p>
          </motion.div>
        </div>
      </div>

      <div className="bg-surface-page py-16">
        <div className="container-custom">
          <div className="mx-auto max-w-3xl space-y-10">
            <section>
              <h2 className="text-xl font-semibold text-slate-900">
                What we optimize for
              </h2>
              <ul className="mt-4 list-inside list-disc space-y-2 text-slate-600">
                <li>Operator clarity: flows that staff can explain in one sentence.</li>
                <li>
                  Compliance realism: verification where policy requires it—not
                  everywhere by default.
                </li>
                <li>
                  Integration hygiene: webhooks and callbacks that behave
                  predictably when systems are under load.
                </li>
              </ul>
            </section>
            <section>
              <h2 className="text-xl font-semibold text-slate-900">
                Working with us
              </h2>
              <p className="mt-4 text-slate-600 leading-relaxed">
                We partner best with teams that can share how check-in works
                today, where pain shows up, and what “good” looks like for
                guests and auditors. If that sounds like you, we would love to
                hear from you.
              </p>
              <Link
                to="/contact"
                className="btn-primary mt-6 inline-flex"
                onClick={() => trackCTA('get_in_touch', 'about_cta')}
              >
                Get in touch
              </Link>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
